function norm(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase();
}

export function isOrigemSecador(lote) {
  const refTipo = norm(lote?.ref_tipo ?? lote?.refTipo);
  return (
    refTipo === 'secador' || refTipo === 'secagem' || refTipo === 'ressecagem'
  );
}

export function isOrigemTerreiro(lote) {
  const refTipo = norm(lote?.ref_tipo ?? lote?.refTipo);
  const etapaTipo = norm(lote?.etapa_tipo ?? lote?.etapaTipo);
  return (
    refTipo === 'lote_terreiro' ||
    refTipo === 'terreiro' ||
    etapaTipo === 'lote_terreiro' ||
    etapaTipo === 'terreiro'
  );
}

export function loteExigeHoraSaidaOrigem(lote) {
  if (!lote || typeof lote !== 'object') return false;

  if (
    Object.prototype.hasOwnProperty.call(lote, 'exige_hora_saida_origem') ||
    Object.prototype.hasOwnProperty.call(lote, 'exigeHoraSaidaOrigem')
  ) {
    return Boolean(lote.exige_hora_saida_origem ?? lote.exigeHoraSaidaOrigem);
  }

  return isOrigemSecador(lote) || isOrigemTerreiro(lote);
}

export function lotesExigemHoraSaidaOrigem(lotes = []) {
  return (lotes || []).some((item) => {
    const lote = item?.lote ?? item;
    return loteExigeHoraSaidaOrigem(lote);
  });
}
